import React, { useEffect, useState } from 'react';
import { useStoreon } from 'storeon/react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import Input from '../Input';
import Radios from '../Radios';
import Select from '../Select';

import FileUploadField from "../FileUploadField/FileUploadField";
import getShipTo from "../../getShipTo/getShipTo";

const BlockDescribeProblem = ( props ) => {
        const [isVisible, setIsVisible] = useState( [false] );
        const { index: blockIndex, disabled = '', idForm, number = true } = props;
        const { watch, trigger, errors, register, setValue } = useFormContext();
        const { groups } = useStoreon( 'groups' );
        const { fields, remove, append } = useFieldArray( {
            name: 'your_project',
        } );
        const { your_project: projects = [] } = watch();
        // These two fields are conditional and used to show additional fields base on value.
        // We have to trigger validation when one of theme go changed so that we can use our logic
        // for fieldsets visibility.
        const salesOrderNumbers = projects.map( ( item ) => item.problem_sales_order_number ).join( ',' );
        const problemDescriptions = projects.map( ( item ) => item.problem_description ).join( ',' );
        const {so, line} = getShipTo();

        useEffect( () => {
            trigger();
        }, [salesOrderNumbers, problemDescriptions, trigger] );

        useEffect( () => {
            register( 'id_form' );
            setValue( 'id_form', idForm );
        }, [register, setValue, idForm] );

        const handleChatLaunch = () => {
            const launchButton = document.getElementById('launch-chat-btn');

            if (launchButton) {
                launchButton.click();
            }
        };

        const fieldsOn = ( isVisible, setIsVisible, index ) => {
            return (
                <>
                    <div className="row">
                        <div className="col col-12 col-sm-6">
                            <Select
                                label="Window/Door Purchase Year"
                                name={`your_project[${index}].window_year`}
                                options={[
                                    {
                                        label: '2026',
                                        value: '2026',
                                    },
                                    {
                                        label: '2025',
                                        value: '2025',
                                    },
                                    {
                                        label: '2024',
                                        value: '2024',
                                    }, {
                                        label: '2023',
                                        value: '2023',
                                    }, {
                                        label: '2022',
                                        value: '2022',
                                    }, {
                                        label: '2021',
                                        value: '2021',
                                    }, {
                                        label: '2020',
                                        value: '2020',
                                    },
                                    {
                                        label: '2019',
                                        value: '2019',
                                    }, {
                                        label: '2018',
                                        value: '2018',
                                    }, {
                                        label: '2017',
                                        value: '2017',
                                    }, {
                                        label: '2016',
                                        value: '2016',
                                    }, {
                                        label: '2015',
                                        value: '2015',
                                    }, {
                                        label: '2014',
                                        value: '2014',
                                    }, {
                                        label: '2013',
                                        value: '2013',
                                    }, {
                                        label: '2012',
                                        value: '2012',
                                    }, {
                                        label: '2011',
                                        value: '2011',
                                    }, {
                                        label: '2010',
                                        value: '2010',
                                    }, {
                                        label: '2009',
                                        value: '2009',
                                    }, {
                                        label: '2008',
                                        value: '2008',
                                    }, {
                                        label: '2007',
                                        value: '2007',
                                    }, {
                                        label: '2006',
                                        value: '2006',
                                    }, {
                                        label: '2005',
                                        value: '2005',
                                    }, {
                                        label: '2004',
                                        value: '2004',
                                    }, {
                                        label: '2003',
                                        value: '2003',
                                    }, {
                                        label: '2002',
                                        value: '2002',
                                    }, {
                                        label: '2001',
                                        value: '2001',
                                    }, {
                                        label: '2000',
                                        value: '2000',
                                    }, {
                                        label: '1999',
                                        value: '1999',
                                    }, {
                                        label: '1998',
                                        value: '1998',
                                    }, {
                                        label: '1997',
                                        value: '1997',
                                    }, {
                                        label: '1996',
                                        value: '1996',
                                    }, {
                                        label: '1995',
                                        value: '1995',
                                    }, {
                                        label: '1994',
                                        value: '1994',
                                    }, {
                                        label: '1993',
                                        value: '1993',
                                    }, {
                                        label: '1992',
                                        value: '1992',
                                    }, {
                                        label: '1991',
                                        value: '1991',
                                    }, {
                                        label: '1990',
                                        value: '1990',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6">
                            <Select
                                label="Does your window/door operate?"
                                name={`your_project[${index}].window_operate`}
                                options={[
                                    {
                                        label: 'Yes, up and down',
                                        value: 'Yes, up and down',
                                    },
                                    {
                                        label: 'Yes, side to side',
                                        value: 'Yes, side to side',
                                    },
                                    {
                                        label: 'It cranks open',
                                        value: 'It cranks open',
                                    },
                                    {
                                        label: 'It swing open',
                                        value: 'It swing open',
                                    },
                                    {
                                        label: 'Not at all',
                                        value: 'Not at all',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-12 col-sm-3">
                            <Input
                                isRequired={false}
                                label="Glass Width (inches)"
                                name={`your_project[${index}].glass_width`}
                                rules={{
                                    pattern: {
                                        value: /^([0-9]|[1-9][0-9]{1,3}|1[0-1][0-9][0-9][0-9]|12[0-2][0-9][9-9]|123[0-3][0-9]|1234[0-4])(\.[0-9]{0,3})?$/,
                                        message:
                                            'Please only include numeric values in field above, ie. 123 or 123.45',
                                    },
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-3">
                            <Input
                                isRequired={false}
                                label="Glass Height (inches)"
                                name={`your_project[${index}].glass_height`}
                                rules={{
                                    pattern: {
                                        value: /^([0-9]|[1-9][0-9]{1,3}|1[0-1][0-9][0-9][0-9]|12[0-2][0-9][9-9]|123[0-3][0-9]|1234[0-4])(\.[0-9]{0,3})?$/,
                                        message:
                                            'Please only include numeric values in field above, ie. 123 or 123.45',
                                    },
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6">
                            <Select
                                label="Select your grid type"
                                name={`your_project[${index}].grid_type`}
                                options={[
                                    {
                                        label: 'I have decorative grids between my glass',
                                        value: 'I have decorative grids between my glass',
                                    },
                                    {
                                        label: 'I have no grids between my glass',
                                        value: 'I have no grids between my glass',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-12 col-sm-6">
                            <Select
                                hint={{
                                    info: 'See more info about',
                                    href: 'https://anlin.com/glass-packages/',
                                    target: '_blank',
                                    linkText: 'glass types.',
                                    boxSize: 'small',
                                }}
                                label="Select your glass type"
                                name={`your_project[${index}].glass_type`}
                                options={[
                                    {
                                        label: 'I have low e glass only',
                                        value: 'I have low e glass only',
                                    },
                                    {
                                        label: 'I have bronze tinted glass',
                                        value: 'I have bronze tinted glass',
                                    },
                                    {
                                        label: 'I have grey tinted glass',
                                        value: 'I have grey tinted glass',
                                    },
                                    {
                                        label: 'I have obscure glass',
                                        value: 'I have obscure glass',
                                    },
                                    {
                                        label: 'I have clear glass',
                                        value: 'I have clear glass',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6">
                            <Select
                                label="Do you need/have tempered safety glass?"
                                name={`your_project[${index}].safety_glass`}
                                options={[
                                    {
                                        label: '60" from a shower or bath tub drain',
                                        value: '60" from a shower or bath tub drain',
                                    },
                                    {
                                        label: 'The glass is less than 24" from a door',
                                        value: 'The glass is less than 24" from a door',
                                    },
                                    {
                                        label: 'The glass is less than 18" from the floor',
                                        value: 'The glass is less than 18" from the floor',
                                    },
                                    {
                                        label: 'None of the above',
                                        value: 'None of the above',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                    </div>
                    <div className="row hidden">
                        <div className="col col-12">
                            <Select
                                label="Window/Door material type"
                                name={`your_project[${index}].window_material`}
                                options={[
                                    {
                                        label: 'Vinyl',
                                        value: 'Vinyl',
                                    },
                                ]}
                                defaultValue="Vinyl"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-12 col-xl-4">
                            <Select
                                label="Problem description"
                                name={`your_project[${index}].problem_description`}
                                options={[
                                    {
                                        label: 'Moisture or discoloration between glass panes',
                                        value: 'Moisture or discoloration between glass panes',
                                    },
                                    {
                                        label: 'Moisture on the interior or exterior of glass surface',
                                        value: 'Moisture on the interior or exterior of glass surface',
                                    },
                                    {
                                        label: 'Window operational issue',
                                        value: 'Window operational issue',
                                    },
                                    {
                                        label: 'Window screen issue',
                                        value: 'Window screen issue',
                                    },
                                    {
                                        label: 'Sliding patio door operational issue',
                                        value: 'Sliding patio door operational issue',
                                    },
                                    {
                                        label: 'Swinging door operational issue',
                                        value: 'Swinging door operational issue',
                                    },
                                    {
                                        label: 'Door screen issue',
                                        value: 'Door screen issue',
                                    },
                                    {
                                        label: 'Other*(please enter additional comments at the end of this page)',
                                        value: 'Other',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <Select
                                hint={{
                                    info: 'What room is your windows/door located on?',
                                    boxSize: 'small',
                                }}
                                label="Room"
                                name={`your_project[${index}].window_location_1`}
                                options={[
                                    {
                                        label: 'Basement',
                                        value: 'Basement',
                                    },
                                    {
                                        label: 'Bathroom',
                                        value: 'Bathroom',
                                    },
                                    {
                                        label: 'Bedroom',
                                        value: 'Bedroom',
                                    },
                                    {
                                        label: 'Bonus',
                                        value: 'Bonus',
                                    },
                                    {
                                        label: 'Den',
                                        value: 'Den',
                                    },
                                    {
                                        label: 'Dining',
                                        value: 'Dining',
                                    },
                                    {
                                        label: 'Entry',
                                        value: 'Entry',
                                    },
                                    {
                                        label: 'Family',
                                        value: 'Family',
                                    },
                                    {
                                        label: 'Garage',
                                        value: 'Garage',
                                    },
                                    {
                                        label: 'Kitchen',
                                        value: 'Kitchen',
                                    },
                                    {
                                        label: 'Living Room',
                                        value: 'Living Room',
                                    },
                                    {
                                        label: 'Master Bath',
                                        value: 'Master Bath',
                                    },
                                    {
                                        label: 'Master Bedroom',
                                        value: 'Master Bedroom',
                                    },
                                    {
                                        label: 'Office',
                                        value: 'Office',
                                    },
                                    {
                                        label: 'Other*(please enter additional comments at the end of this page)',
                                        value: 'Other',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <Select
                                hint={{
                                    info: 'What floor is your windows/door located on?',
                                    boxSize: 'small',
                                }}
                                label="Floor"
                                name={`your_project[${index}].window_location_2`}
                                options={[
                                    {
                                        label: '1st floor',
                                        value: '1st floor',
                                    },
                                    {
                                        label: '2nd floor',
                                        value: '2nd floor',
                                    },
                                    {
                                        label: '3rd floor',
                                        value: '3rd floor',
                                    },
                                    {
                                        label: '4th floor',
                                        value: '4th floor',
                                    },
                                    {
                                        label: 'Basement',
                                        value: 'Basement',
                                    },
                                    {
                                        label: 'Other* (please enter additional comments at the end of this page)',
                                        value: 'Other',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <Select
                                hint={{
                                    info: 'From the inside of the home, is the window accessible at floor level up to 6’?',
                                    boxSize: 'small',
                                }}
                                label="Accessibility"
                                name={`your_project[${index}].window_door_accessible`}
                                options={[
                                    {
                                        label: 'Yes',
                                        value: 'Yes',
                                    },
                                    {
                                        label: 'No',
                                        value: 'No',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <FileUploadField
                                hint={{
                                    info: 'You can upload up to four pictures to accompany this window/door. Files must be less than 25 MB. Allowed file types: png gif jpg jpeg.',
                                    boxSize: 'small',
                                }}
                                isVisible={isVisible}
                                changeState={setIsVisible}
                                id={index}
                                name={`your_project[${index}].download_files`}
                            />
                        </div>
                    </div>
                </>
            )
        }

        const fieldsYes = ( isVisible, setIsVisible, index ) => {
            return (
                <>
                    <div className="row row--inline">
                        <div className="col col-12 col-md-6 col-lg-4">
                            <h3>Provide Sales Order & Line Number</h3>
                        </div>
                        <div className="col col-12 col-md-6 col-lg-8">
                            <div className="row">
                                <div className="col col-12 col-sm-6">
                                    <Input
                                        hint={{
                                            img: '/modules/custom/milgard_service_request/assets/images/order-number.png',
                                            href: 'https://anlin.com/locate-order-number/',
                                            target: '_blank',
                                            linkText: 'Click here for help finding your order and line numbers.'
                                        }}
                                        label="Sales order number"
                                        name={`your_project[${index}].order_number`}
                                        rules={{
                                            required: 'This field is required.',
                                            pattern: {
                                                value: /^(\d{6,9}){1}$/,
                                                message:
                                                    'Please only enter the first numbers before the decimal point. Sales order numbers are between 6 and 9 digits.',
                                            },
                                        }}
                                        defaultValue={
                                            projects[index] &&
                                            projects[index].sales_order_number_same_as_above === 'yes'
                                                ? projects[index - 1].order_number
                                                : so ? so : null
                                        }
                                    />
                                </div>
                                <div className="col col-12 col-sm-6">
                                    <Input
                                        hint={{
                                            img: '/modules/custom/milgard_service_request/assets/images/order-number.png',
                                            href: 'https://anlin.com/locate-order-number/',
                                            target: '_blank',
                                            linkText: 'Click here for help finding your order and line numbers.'
                                        }}
                                        label="Line number"
                                        name={`your_project[${index}].order_number_line`}
                                        rules={{
                                            pattern: {
                                                value: /^[0-9]{3}$/,
                                                message:
                                                    'The line number should contain 3 characters (numbers only).',
                                            },
                                        }}
                                        defaultValue={line}
                                        isRequired={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col col-12 col-xl-4">
                            <Select
                                label="Problem description"
                                name={`your_project[${index}].problem_description`}
                                options={[
                                    {
                                        label: 'Moisture or discoloration between glass panes',
                                        value: 'Moisture or discoloration between glass panes',
                                    },
                                    {
                                        label: 'Moisture on the interior or exterior of glass surface',
                                        value: 'Moisture on the interior or exterior of glass surface',
                                    },
                                    {
                                        label: 'Window operational issue',
                                        value: 'Window operational issue',
                                    },
                                    {
                                        label: 'Window screen issue',
                                        value: 'Window screen issue',
                                    },
                                    {
                                        label: 'Sliding patio door operational issue',
                                        value: 'Sliding patio door operational issue',
                                    },
                                    {
                                        label: 'Swinging door operational issue',
                                        value: 'Swinging door operational issue',
                                    },
                                    {
                                        label: 'Door screen issue',
                                        value: 'Door screen issue',
                                    },
                                    {
                                        label: 'Other*(please enter additional comments at the end of this page)',
                                        value: 'Other',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <Select
                                hint={{
                                    info: 'What room is your windows/door located on?',
                                    boxSize: 'small',
                                }}
                                label="Room"
                                name={`your_project[${index}].window_location_1`}
                                options={[
                                    {
                                        label: 'Basement',
                                        value: 'Basement',
                                    },
                                    {
                                        label: 'Bathroom',
                                        value: 'Bathroom',
                                    },
                                    {
                                        label: 'Bedroom',
                                        value: 'Bedroom',
                                    },
                                    {
                                        label: 'Bonus',
                                        value: 'Bonus',
                                    },
                                    {
                                        label: 'Den',
                                        value: 'Den',
                                    },
                                    {
                                        label: 'Dining',
                                        value: 'Dining',
                                    },
                                    {
                                        label: 'Entry',
                                        value: 'Entry',
                                    },
                                    {
                                        label: 'Family',
                                        value: 'Family',
                                    },
                                    {
                                        label: 'Garage',
                                        value: 'Garage',
                                    },
                                    {
                                        label: 'Kitchen',
                                        value: 'Kitchen',
                                    },
                                    {
                                        label: 'Living Room',
                                        value: 'Living Room',
                                    },
                                    {
                                        label: 'Master Bath',
                                        value: 'Master Bath',
                                    },
                                    {
                                        label: 'Master Bedroom',
                                        value: 'Master Bedroom',
                                    },
                                    {
                                        label: 'Office',
                                        value: 'Office',
                                    },
                                    {
                                        label: 'Other*(please enter additional comments at the end of this page)',
                                        value: 'Other',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <Select
                                hint={{
                                    info: 'What floor is your windows/door located on?',
                                    boxSize: 'small',
                                }}
                                label="Floor"
                                name={`your_project[${index}].window_location_2`}
                                options={[
                                    {
                                        label: '1st floor',
                                        value: '1st floor',
                                    },
                                    {
                                        label: '2nd floor',
                                        value: '2nd floor',
                                    },
                                    {
                                        label: '3rd floor',
                                        value: '3rd floor',
                                    },
                                    {
                                        label: '4th floor',
                                        value: '4th floor',
                                    },
                                    {
                                        label: 'Basement',
                                        value: 'Basement',
                                    },
                                    {
                                        label: 'Other*(please enter additional comments at the end of this page)',
                                        value: 'Other',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <Select
                                hint={{
                                    info: 'From the inside of the home, is the window accessible at floor level up to 6’?',
                                    boxSize: 'small',
                                }}
                                label="Accessibility"
                                name={`your_project[${index}].window_door_accessible`}
                                options={[
                                    {
                                        label: 'Yes',
                                        value: 'Yes',
                                    },
                                    {
                                        label: 'No',
                                        value: 'No',
                                    },
                                    {
                                        label: "I don't know",
                                        value: "I don't know",
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                            />
                        </div>
                        <div className="col col-12 col-sm-6 col-md-3 col-xl-2">
                            <FileUploadField
                                hint={{
                                    info: 'You can upload up to four pictures to accompany this window/door. Files must be less than 25 MB. Allowed file types: png gif jpg jpeg.',
                                    boxSize: 'small',
                                }}
                                isVisible={isVisible}
                                changeState={setIsVisible}
                                id={index}
                                name={`your_project[${index}].download_files`}
                            />
                        </div>
                    </div>

                    {projects[index] &&
                    [
                        'Moisture or discoloration between glass panes',
                        'Moisture on the interior or exterior of glass surface',
                    ].includes( projects[index].problem_description ) && (
                        <div className="row">
                            <div className="col col-12 col-xl-4">
                                <Select
                                    label="Which glass section needs to be serviced?"
                                    name={`your_project[${index}].which_glass_serviced`}
                                    options={[
                                        {
                                            label: 'Moving section',
                                            value: 'Moving section',
                                        },
                                        {
                                            label: 'Stationary section',
                                            value: 'Stationary section',
                                        },
                                        {
                                            label: 'Both moving and stationary section',
                                            value: 'Both moving and stationary section',
                                        },
                                        {
                                            label: 'Non-rectangular or radius shaped glass',
                                            value: 'Non-rectangular or radius shaped glass',
                                        },
                                    ]}
                                    rules={{
                                        required: 'This field is required.',
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {projects[index] && projects[index].problem_description === 'Window operational issue' && (
                        <div className="row">
                            <div className="col col-12 col-xl-4">
                                <Select
                                    label="My windows issue is"
                                    name={`your_project[${index}].windows_issue`}
                                    options={[
                                        {
                                            label: 'Vertical slider does not stay up',
                                            value: 'Vertical slider does not stay up',
                                        },
                                        {
                                            label: 'Vertical slider does not lock well',
                                            value: 'Vertical slider does not lock well',
                                        },
                                        {
                                            label: 'Horizontal slider does not slide well',
                                            value: 'Horizontal slider does not slide well',
                                        },
                                        {
                                            label: 'Horizontal slider does not lock well',
                                            value: 'Horizontal slider does not lock well',
                                        },
                                        {
                                            label: 'Cranking window does not operate well',
                                            value: 'Cranking window does not operate well',
                                        },
                                        {
                                            label:
                                                'Other*(please enter additional comments at the end of this page)',
                                            value: 'Other',
                                        },
                                    ]}
                                    rules={{
                                        required: 'This field is required.',
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {projects[index] &&
                    [
                        'Sliding patio door operational issue',
                        'Swinging door operational issue',
                    ].includes( projects[index].problem_description ) && (
                        <div className="row">
                            <div className="col col-12 col-xl-4">
                                <Select
                                    label="My door issue is"
                                    name={`your_project[${index}].door_issue`}
                                    options={[
                                        {
                                            label: 'Door does not lock well',
                                            value: 'Door does not lock well',
                                        },
                                        {
                                            label: 'Door does not slide well',
                                            value: 'Door does not slide well',
                                        },
                                        {
                                            label:
                                                'Other*(please enter additional comments at the end of this page)',
                                            value: 'Other',
                                        },
                                    ]}
                                    rules={{
                                        required: 'This field is required.',
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </>
            )
        }

        return (
            <fieldset className="form-block" disabled={disabled === '' ? groups[blockIndex].disabled : disabled}>
                <legend className="form-block__title">{number ? blockIndex + 1 + '.' : ''} Please Describe the Problem</legend>
                {fields.map( ( item, index ) => {
                    return (
                        <div className={`block-form block--describe-your-problem`} key={item.id}>
                            {!!index && (
                                <>
                                    <h2 className={'block__title'}>Door/Window Problem #{index + 1}</h2>
                                    <button
                                        className={`button button--remove-problem`}
                                        type="button"
                                        aria-label="Remove problem block"
                                        onClick={() => remove( index )}
                                    >
                                        ×
                                    </button>
                                </>
                            )}
                            <Radios
                                hint={{
                                    boxDirection: 'bottom',
                                    img: '/modules/custom/milgard_service_request/assets/images/order-number.png',
                                    href: 'https://anlin.com/locate-order-number/',
                                    target: '_blank',
                                    linkText: 'Click here for help finding your order and line numbers.'
                                }}
                                label="Do you have your Sales Order Number?"
                                name={`your_project[${index}].problem_sales_order_number`}
                                options={[
                                    {
                                        label: 'Yes',
                                        value: 'yes',
                                    },
                                    {
                                        label: 'No',
                                        value: 'no',
                                    },
                                ]}
                                rules={{
                                    required: 'This field is required.',
                                }}
                                defaultValue={
                                    so ? 'yes' : null
                                }
                            />

                            {index > 0 && (
                                <Radios
                                    label="Same Sales Order Number as Above?"
                                    name={`your_project[${index}].sales_order_number_same_as_above`}
                                    options={[
                                        {
                                            label: 'Yes',
                                            value: 'yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'no',
                                        },
                                    ]}
                                    defaultValue="yes"
                                    rules={{
                                        required: 'This field is required.',
                                    }}
                                />
                            )}

                            {/* If no select order number selected */}
                            {projects[index] && projects[index].problem_sales_order_number === 'no'
                                ? fieldsOn( isVisible, setIsVisible, index )
                                : fieldsYes( isVisible, setIsVisible, index )}
                            {!errors.your_project && index === fields.length - 1 && (
                                <button
                           	 className={`button button--add-problem`}
                      		 type="button"
    				 onClick={() =>
        				append({
           				  problem_sales_order_number: 'yes',  // Default to 'yes' for new entries
            				  sales_order_number_same_as_above: 'yes', // Default for the same sales order
        				})
    				 }
				>+ Add another door/window
				</button>
                            )}
                        </div>
                    );
                } )}
                {!groups[blockIndex].disabled &&
                groups[blockIndex + 1] &&
                groups[blockIndex + 1].disabled && (
                    <div className={'form-block__error'}>
                        You must fill in all required fields prior to moving to the next section.
                    </div>
                )}
            </fieldset>
        );
    }
;

BlockDescribeProblem.propTypes = {
    index: PropTypes.number.isRequired,
};

export default BlockDescribeProblem;
